module.exports = __webpack_public_path__ + "img/arrow-down-left-square.e704ae01.svg";